import { render, staticRenderFns } from "./PageExchange.vue?vue&type=template&id=34e501af&scoped=true"
import script from "./PageExchange.vue?vue&type=script&lang=js"
export * from "./PageExchange.vue?vue&type=script&lang=js"
import style0 from "./PageExchange.vue?vue&type=style&index=0&id=34e501af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e501af",
  null
  
)

export default component.exports